import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { LinkGroup } from '../_models/link-group.model';
import { QueryParamsModel } from '../../_base/crud';

export enum LinkGroupActionTypes {
  LinkGroupsPageRequested = '[LinkGroups] LinkGroups Page Requested',
  LinkGroupsPageLoaded = '[LinkGroups] LinkGroups Page Loaded',
  LinkGroupsRequested = '[LinkGroups] LinkGroups Requested',
  LinkGroupsLoaded = '[LinkGroups] LinkGroups Loaded',
  LinkGroupsPageCancelled = '[LinkGroups] LinkGroups Page Cancelled',
  LinkGroupOnServerCreated = '[LinkGroups] LinkGroup On Server Created',
  LinkGroupOnServerUpdated = '[LinkGroups] LinkGroup On Server Updated',
  LinkGroupOnServerDeleted = '[LinkGroups] LinkGroup On Server Deleted',
  ThrowLinkGroupError = '[LinkGroups] Throw Error',
  FireLinkGroupSuccess = '[LinkGroups] Fire Success',
  LinkGroupsPageToggleLoading = '[LinkGroups] LinkGroups Page Toggle Loading',
  ClearLinkGroupState = '[LinkGroups] Clear LinkGroup State',
}

export class LinkGroupOnServerCreated implements Action {
  readonly type = LinkGroupActionTypes.LinkGroupOnServerCreated;

  constructor(public payload: { body: any }) {}
}

export class ThrowLinkGroupError implements Action {
  readonly type = LinkGroupActionTypes.ThrowLinkGroupError;

  constructor(public payload: { error: any }) {}
}

export class FireLinkGroupSuccess implements Action {
  readonly type = LinkGroupActionTypes.FireLinkGroupSuccess;

  constructor(public payload: { action_type: string }) {}
}

export class LinkGroupOnServerUpdated implements Action {
  readonly type = LinkGroupActionTypes.LinkGroupOnServerUpdated;

  constructor(
    public payload: {
      partialLinkGroup: Update<LinkGroup>;
      linkGroup: LinkGroup;
    },
  ) {}
}

export class LinkGroupOnServerDeleted implements Action {
  readonly type = LinkGroupActionTypes.LinkGroupOnServerDeleted;

  constructor(public payload: { id: number }) {}
}

export class LinkGroupsPageRequested implements Action {
  readonly type = LinkGroupActionTypes.LinkGroupsPageRequested;

  constructor(public payload: { page: QueryParamsModel }) {}
}

export class LinkGroupsPageLoaded implements Action {
  readonly type = LinkGroupActionTypes.LinkGroupsPageLoaded;

  constructor(
    public payload: { linkGroups: LinkGroup[]; totalCount: number; page: QueryParamsModel },
  ) {}
}

export class LinkGroupsRequested implements Action {
  readonly type = LinkGroupActionTypes.LinkGroupsRequested;
}

export class LinkGroupsLoaded implements Action {
  readonly type = LinkGroupActionTypes.LinkGroupsLoaded;

  constructor(public payload: { linkGroups: LinkGroup[] }) {}
}

export class LinkGroupsPageCancelled implements Action {
  readonly type = LinkGroupActionTypes.LinkGroupsPageCancelled;
}

export class LinkGroupsPageToggleLoading implements Action {
  readonly type = LinkGroupActionTypes.LinkGroupsPageToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class ClearLinkGroupState implements Action {
  readonly type = LinkGroupActionTypes.ClearLinkGroupState;
}

export type LinkGroupActions =
  | LinkGroupOnServerCreated
  | LinkGroupOnServerUpdated
  | LinkGroupOnServerDeleted
  | LinkGroupsPageRequested
  | LinkGroupsPageLoaded
  | LinkGroupsRequested
  | LinkGroupsLoaded
  | LinkGroupsPageCancelled
  | LinkGroupsPageToggleLoading
  | ThrowLinkGroupError
  | FireLinkGroupSuccess
  | ClearLinkGroupState;
